export class ProgramaPacDto{
    id: number;
    idPrograma: number;
    idSubPrograma: number;
    nomeProgramaSubPrograma: string;
}